<template>
  <div id="document-list-page">
    <v-container>
      <div class="_fs-36">
        เอกสารใบเสนอราคา
      </div>

      <template v-if="orders.length > 0">
        <v-card
          v-for="{ _id, code, createdAt, email } in orders"
          :key="_id"
          class="mt-4 pa-4">
          <v-row align="center">
            <v-col
              cols="12"
              sm="3">
              <router-link
                :to="{ name: 'OrderDetail', params: { id: _id } }"
                class="font-weight-bold">
                {{ code }}
              </router-link>
            </v-col>
            <v-col
              cols="12"
              sm="3">
              <span class="d-sm-none">
                วันที่ทำการซื้อ:
              </span>
              {{ createdAt | dateTimeFormat('DD MMM YYYY - HH:mm') }}
            </v-col>
            <v-col
              class="text-center text-sm-end"
              cols="12"
              sm="6">
              <v-btn
                color="primary"
                rounded
                min-width="200"
                @click="onRequestDocument(_id, email)">
                ส่งเอกสาร
              </v-btn>
            </v-col>
          </v-row>
        </v-card>

        <v-pagination
          class="mt-4"
          :value="page"
          :length="ordersPageData.totalPages"
          @input="onChangePage">
        </v-pagination>
      </template>
      <div
        v-else
        class="py-10 text-center grey--text _fs-20">
        ไม่มีข้อมูลไฟล์หลักฐานของ Basic ID นี้
      </div>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { mapWaitingActions } from 'vue-wait'
import store from '@/store'

const status = 'new,pending,rejected'

export default {
  name: 'DocumentListPage',
  data () {
    return {
      page: +this.$route.query.page || 1
    }
  },
  computed: {
    ...mapState('Order', ['orders', 'ordersPageData'])
  },
  async beforeRouteEnter (to, from, next) {
    store.dispatch('wait/start', 'app loading', { root: true })
    await store.dispatch('Order/fetchOrders', {
      page: to.query.page || 1,
      status
    })
    store.dispatch('wait/end', 'app loading', { root: true })
    next()
  },
  methods: {
    ...mapActions({
      fetchOrders: 'Order/fetchOrders',
      fetchEmailCreateOrderById: 'Email/fetchEmailCreateOrderById'
    }),
    ...mapWaitingActions('Order', {
      fetchOrders: 'app loading'
    }),
    ...mapWaitingActions('Email', {
      fetchEmailCreateOrderById: 'app loading'
    }),
    async onRequestDocument (orderId, email) {
      await this.fetchEmailCreateOrderById(orderId)
      this.$swal({
        title: 'ดำเนินการเรียบร้อย',
        html: `เอกสารใบเสนอราคาได้ส่งไปที่ Email: <b>${email}</b><br>โปรดตรวจสอบที่ Inbox ใน Email`,
        icon: 'success'
      })
    },
    onChangePage (page) {
      this.page = page
      this.fetchOrders({
        page: this.page,
        status
      })
      this.$router.replace({ name: 'OrderList', query: { page } })
    }
  }
}
</script>
